'use client'

import { Image, getTranslations } from '@/lib/next-shim'
import { Link } from '@/lib/i18n/settings'

import { AccountMenu } from '@/features/account-menu'
import { LanguageSwitcher } from '@/shared/ui/LanguageSwitcher'
import LinkButton from '@/components/external/material/LinkButton'

import logoGif from '@/assets/img/logo.gif'
import { useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { getEnv } from '@/lib/env'
import { shouldUseCustomBranding } from '@/utils/landing-variant'

export function Header() {
  const { data: session } = useSession()
  const t = getTranslations()

  // Get branding information for white labeling
  const isCustomBranded = shouldUseCustomBranding()
  const brandLogo = getEnv('NEXT_PUBLIC_BRAND_LOGO', '')
  const brandName = getEnv('NEXT_PUBLIC_BRAND_NAME', 'Medconnect Platform')

  return (
    <header className="bg-white shadow">
      <div className="flex items-center h-16 px-4 sm:px-6 lg:px-8">
        <div>
          <Link className="flex items-center justify-center" href="/">
            {isCustomBranded && brandLogo ? (
              <Image alt={brandName} src={brandLogo} width={107} height={60} className="h-16 w-auto object-contain" />
            ) : (
              <Image alt="logo" src={logoGif} width={107} height={60} className="h-16 w-auto" />
            )}
          </Link>
        </div>
        <div className="flex flex-1 items-center justify-end gap-x-2 sm:gap-x-3">
          {!session ? (
            <>
              <LinkButton className="hidden md:block" href="/login">
                {t('button.signIn.label')}
              </LinkButton>
              <LinkButton color="primary" disableElevation href="/register" variant="contained">
                {t('button.signUp.label')}
              </LinkButton>
            </>
          ) : (
            <AccountMenu />
          )}
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>
          <div className="block md:hidden">
            <LanguageSwitcher isMobile />
          </div>
        </div>
      </div>
    </header>
  )
}
